export enum EnumTipoFinanceiro
{
    Receita = 1,
    Despesa
}

export const ListaTipoFinanceiro = [
  { descricao: "Receita", valor: EnumTipoFinanceiro.Receita },
  { descricao: "Despesa", valor: EnumTipoFinanceiro.Despesa }
];